import { Logger } from 'data/common';
import { fromJS } from 'immutable';

function debug(eventName, params) {
    Logger.debug(`Fhe : <---------- Event Received ${eventName}`, params);
}

function bindSettingsEvents(ProductInstance) {}

export default function initBinds(ProductInstance) {
    bindSettingsEvents(ProductInstance);
}



// WEBPACK FOOTER //
// ./environments/fhe/eventsSocket/PushNotification/binds.js